//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Mantle_cell_lymphoma',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '＜50'},
        {value: '1', name: '50~59'},
        {value: '2', name: '60~69'},
        {value: '3', name: '≥70'}
      ],
      dataList2: [
        {value: '0', name: '0~1%'},
        {value: '2', name: '2~4%'}
      ],
      dataList3: [
        {value: '0', name: '＜0.67'},
        {value: '1', name: '0.67~0.99'},
        {value: '2', name: '1.00~1.49'},
        {value: '3', name: '≥1.50'}
      ],
      dataList4: [
        {value: '0', name: '＜6.70'},
        {value: '1', name: '6.70~9.99'},
        {value: '2', name: '10.00~14.99'},
        {value: '3', name: '≥15.00'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Mantle_cell_lymphoma.vue